import { styled, Stack } from '@mui/material';

export const Container = styled(Stack)({
  flexDirection: 'row',
  minHeight: '100vh',
  boxSizing: 'border-box',
  width: '100%',
});

export const FormContainer = styled(Stack)(({ theme }) => ({
  flex: 1,
  padding: '20px',

  gap: '40px',
  margin: '0 auto',

  [theme.breakpoints.up('laptop')]: {
    padding: '40px 40px 0',
  },
}));

export const IntroductonContainer = styled(Stack)(({ theme }) => ({
  flex: 1,
  display: 'none',

  [theme.breakpoints.up('laptop')]: {
    display: 'flex',
  },
}));
